import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=73e0f1d0&scoped=true&"
import script from "./DataPrivacy.vue?vue&type=script&lang=ts&"
export * from "./DataPrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./DataPrivacy.vue?vue&type=style&index=0&id=73e0f1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e0f1d0",
  null
  
)

export default component.exports